function css3DNode(elem, fr) {
	this.forceRefresh = fr;
	
	if (elem != "") this.element = $(elem);
	else this.element = false;
	
	this.transforms = [];
	this.children = [];
	this.last = null;
	
	this.resetTransform = function() {
		this.transforms = [];
	}
	
	this.addChild = function(o) {
		this.children.push(o);
	};
	
	this.getChildAt = function(i) {
		return this.children[i];
	};
	
	this.swapChildren = function(a,b) {
		var cld = this.children[a];
		this.children[a] = this.children[b];
		this.children[b] = cld;
	};
	
	this.translate = function(tx, ty, tz) {
		obj = {};
		obj.op = "translate";
		obj.x = tx;
		obj.y = ty;
		obj.z = tz;
	
		this.last = obj;	
		this.transforms.push(obj);
	};

	this.scale = function(tx, ty, tz) {
		obj = {};
		obj.op = "scale";
		obj.x = tx;
		obj.y = ty;
		obj.z = tz;
		
		this.last = obj;	
		this.transforms.push(obj);
	};
	
	this.scale2D = function(tx, ty) {
		obj = {};
		obj.op = "scale2D";
		obj.x = tx;
		obj.y = ty;
		
		this.last = obj;	
		this.transforms.push(obj);
	};
	
	this.rotateX = function(deg) {
		obj = {};
		obj.op = "rotateX";
		obj.deg = deg % 360;
		
		this.last = obj;	
		this.transforms.push(obj);
	};
	
	this.rotateY = function(deg) {
		obj = {};
		obj.op = "rotateY";
		obj.deg = deg % 360;
		
		this.last = obj;	
		this.transforms.push(obj);
	};
	
	this.rotateZ = function(deg) {
		obj = {};
		obj.op = "rotateZ";
		obj.deg = deg % 360;
		
		this.last = obj;	
		this.transforms.push(obj);
	};

	this.appendTransforms = function(o) {
		for(var i = 0; i < o.length; i ++) {
			this.transforms.push(o[i]);
		}
	};
	
	this.transformStack = function() {
		return this.transforms;
	};
	
	this.applyTransformsWith = function(parentTransforms) {
		var trans = "";
		var currentTransforms;
		
		currentTransforms = this.transforms;
				
		if (parentTransforms != false) {
			for(var i = 0; i < parentTransforms.length; i ++) {
				currentTransforms.push(parentTransforms[i]);
			}
		}
				
		for(var i = 0; i < this.children.length; i ++) {
			this.children[i].applyTransformsWith(currentTransforms);
		};
		
		if (this.element != false) {
			for(var i = 0; i < currentTransforms.length; i ++) {
				obj = currentTransforms[i];
				
				switch(obj.op) {
					case "translate":
						trans += "translate3d(" + obj.x + "px," + obj.y + "px, " + obj.z + "px) ";
					break;
					case "rotateX":
						trans += "rotateX(" + obj.deg + "deg) ";
					break;
					case "rotateY":
						trans += "rotateY(" + obj.deg + "deg) ";
					break;
					case "rotateZ":
						trans += "rotateZ(" + obj.deg + "deg) ";
					break;
					case "scale":
						trans += "scale3d(" + obj.x + ", " + obj.y + ", " + obj.z + ") ";
					break;
					case "scale2D":
						trans += "scale(" + obj.x + ", " + obj.y + ") ";
					break;
				}
			}
		
			this.element.css("transform",trans);
			this.element.css("-webkit-transform",trans);
			if (this.forceRefresh) {
				//this.element.attr("class","hack" + Math.round(Math.random() * 1000));
				//document.body.style.display = 'none';
				//document.body.style.display = 'block';
				var redraw = this.element.get(0).offsetHeight;
			}
		}
	};
	
	this.applyTransforms = function() {
		this.applyTransformsWith(false);
	}
}